import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _objectDestructuringEmpty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.promise.finally.js";
import e from "react";
import { Dialog as t } from "@reach/dialog";
import n from "@reach/visually-hidden";
import { useIdentityContext as r, IdentityContextProvider as a } from "react-netlify-identity";
export { useNetlifyIdentity } from "react-netlify-identity";
import { Tabs as l, TabList as o, Tab as s, TabPanels as i, TabPanel as c } from "@reach/tabs";

function m() {
  var _e$useState = e.useState(!1),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      t = _e$useState2[0],
      n = _e$useState2[1],
      r = e.useRef(!1);

  return e.useEffect(function () {
    return r.current = !0, function () {
      return void (r.current = !1);
    };
  }, []), [t, function (e) {
    return n(!0), e.finally(function () {
      return r.current && n(!1);
    });
  }];
}

function u() {
  var _r = r(),
      t = _r.loginUser,
      a = e.useRef(null),
      _e$useState3 = e.useState(""),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      l = _e$useState4[0],
      o = _e$useState4[1],
      _m = m(),
      _m2 = _slicedToArray(_m, 2),
      s = _m2[0],
      i = _m2[1];

  return e.createElement("form", {
    ref: a,
    className: "form",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      var n = e.target,
          r = n.email.value,
          a = n.password.value;
      i(t(r, a, !0)).then(function (e) {
        console.log("Success! Logged in", e);
      }).catch(function (e) {
        return void console.error(e) || o("Error: " + e.message);
      });
    }
  }, e.createElement("div", {
    className: "formGroup",
    key: "email"
  }, e.createElement("label", null, e.createElement(n, null, "Enter your email"), e.createElement("input", {
    className: "formControl",
    type: "email",
    name: "email",
    placeholder: "Email",
    autoCapitalize: "off",
    required: !0
  }), e.createElement("div", {
    className: "inputFieldIcon inputFieldEmail"
  }))), e.createElement("div", {
    className: "formGroup",
    key: "password"
  }, e.createElement("label", null, e.createElement(n, null, "Enter your password"), e.createElement("input", {
    className: "formControl",
    type: "password",
    name: "password",
    placeholder: "Password",
    required: !0
  }), e.createElement("div", {
    className: "inputFieldIcon inputFieldPassword"
  }))), e.createElement("div", null, e.createElement("button", {
    type: "submit",
    className: s ? "btn saving" : "btn"
  }, "Log in"), l && e.createElement("pre", {
    style: {
      background: "salmon",
      padding: 10
    }
  }, l)), e.createElement("button", {
    type: "button",
    className: "btnLink forgotPasswordLink"
  }, "Forgot password?"));
}

function d() {
  var t = r(),
      n = t && t.user && t.user.user_metadata && t.user.user_metadata.full_name || "NoName",
      _m3 = m(),
      _m4 = _slicedToArray(_m3, 2),
      a = _m4[0],
      l = _m4[1];

  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: "header"
  }, e.createElement("button", {
    className: "btn btnHeader active"
  }, "Logged in")), e.createElement("form", {
    className: "form "
  }, e.createElement("p", {
    className: "infoText"
  }, "Logged in as ", e.createElement("br", null), e.createElement("span", {
    className: "infoTextEmail"
  }, n)), e.createElement("button", {
    type: "submit",
    className: a ? "btn saving" : "btn",
    onClick: function onClick() {
      return l(t.logoutUser());
    }
  }, "Log out")));
}

function p() {
  var _r2 = r(),
      t = _r2.signupUser,
      a = e.useRef(null),
      _e$useState5 = e.useState(""),
      _e$useState6 = _slicedToArray(_e$useState5, 2),
      l = _e$useState6[0],
      o = _e$useState6[1],
      _m5 = m(),
      _m6 = _slicedToArray(_m5, 2),
      s = _m6[0],
      i = _m6[1];

  return e.createElement("form", {
    ref: a,
    className: "form",
    onSubmit: function onSubmit(e) {
      e.preventDefault(), function () {
        if (!a.current) return;
        var e = a.current.username.value,
            n = a.current.email.value,
            r = a.current.password.value,
            l = {
          signupSource: "react-netlify-identity-widget",
          full_name: e
        };
        i(t(n, r, l)).then(function (e) {
          console.log("Success! Signed up", e);
        }).catch(function (e) {
          return void console.error(e) || o("Error: " + e.message);
        });
      }();
    }
  }, e.createElement("div", {
    className: "formGroup",
    key: "username"
  }, e.createElement("label", null, e.createElement(n, null, "Enter your name"), e.createElement("input", {
    id: "username",
    className: "formControl",
    type: "name",
    name: "username",
    placeholder: "Name",
    autoCapitalize: "off",
    required: !0
  }), e.createElement("div", {
    className: "inputFieldIcon inputFieldName"
  }))), e.createElement("div", {
    className: "formGroup",
    key: "email"
  }, e.createElement("label", null, e.createElement(n, null, "Enter your email"), e.createElement("input", {
    className: "formControl",
    type: "email",
    name: "email",
    placeholder: "Email",
    autoCapitalize: "off",
    required: !0
  }), e.createElement("div", {
    className: "inputFieldIcon inputFieldEmail"
  }))), e.createElement("div", {
    className: "formGroup",
    key: "password"
  }, e.createElement("label", null, e.createElement(n, null, "Enter your password"), e.createElement("input", {
    className: "formControl",
    type: "password",
    name: "password",
    placeholder: "Password",
    required: !0
  }), e.createElement("div", {
    className: "inputFieldIcon inputFieldPassword"
  }))), e.createElement("div", null, e.createElement("button", {
    type: "submit",
    className: s ? "btn saving" : "btn"
  }, "Sign Up"), l && e.createElement("pre", {
    style: {
      background: "salmon",
      padding: 10
    }
  }, l)));
}

function E() {
  var _r3 = r(),
      t = _r3.settings,
      n = Object.entries(t.external).some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        e = _ref2[0],
        t = _ref2[1];

    return ["github", "gitlab", "bitbucket", "google"].includes(e) && t;
  });

  if (!n) return null;
  var a = !1;
  return "undefined" != typeof window && (a = Boolean("localhost" === window.location.hostname || "[::1]" === window.location.hostname || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/))), e.createElement("div", {
    className: "providersGroup"
  }, a && e.createElement("pre", null, "⚠️Testing providers on localhost won't work because OAuth redirects to your production site"), e.createElement("hr", {
    className: "hr"
  }), e.createElement(f, {
    settings: t,
    provider: "Google"
  }), e.createElement(f, {
    settings: t,
    provider: "GitHub"
  }), e.createElement(f, {
    settings: t,
    provider: "GitLab"
  }), e.createElement(f, {
    settings: t,
    provider: "Bitbucket"
  }));
}

function f(_ref3) {
  var t = _ref3.settings,
      n = _ref3.provider;
  var a = t.external;
  if (!a[n.toLowerCase()]) return null;

  var _r4 = r(),
      l = _r4.loginProvider;

  return e.createElement("button", {
    onClick: function onClick() {
      return l(n.toLowerCase());
    },
    className: "provider".concat(n, " btn btnProvider")
  }, "Continue with ", n);
}

function g() {
  return e.createElement("div", null, e.createElement(l, {
    defaultIndex: 0
  }, e.createElement(o, {
    className: "header"
  }, e.createElement(s, {
    className: "btn btnHeader"
  }, "Login"), e.createElement(s, {
    className: "btn btnHeader"
  }, "Sign Up")), e.createElement(i, null, e.createElement(c, null, e.createElement(u, null)), e.createElement(c, null, e.createElement(p, null)))), e.createElement(E, null));
}

function b() {
  return e.createElement(d, null);
}

function v(_ref4) {
  _objectDestructuringEmpty(_ref4);

  var t = r(),
      n = Boolean(t && t.user);
  return e.createElement(n ? b : g, null);
}

function h(_ref5) {
  var t = _ref5.onCloseDialog;
  return e.createElement(v, {
    onCloseDialog: t
  });
}

var N = /*#__PURE__*/function (_e$Component) {
  _inherits(N, _e$Component);

  var _super = _createSuper(N);

  function N(e) {
    var _this;

    _classCallCheck(this, N);

    _this = _super.call(this, e), _this.state = {
      hasError: !1
    };
    return _this;
  }

  _createClass(N, [{
    key: "render",
    value: function render() {
      return this.state.hasError ? e.createElement("h1", null, "Something went loading the widget.") : this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: !0
      };
    }
  }]);

  return N;
}(e.Component);

var y = a,
    w = r;

function C(_ref6) {
  var r = _ref6.showDialog,
      a = _ref6.onCloseDialog;
  return e.createElement(t, {
    isOpen: r,
    onDismiss: a,
    style: {
      border: "solid 5px hsla(0, 0%, 0%, 0.5)",
      borderRadius: "10px",
      position: "relative",
      maxWidth: 400
    }
  }, e.createElement("button", {
    className: "btn btnClose",
    onClick: a
  }, e.createElement(n, null, "Close")), e.createElement(N, null, e.createElement(e.Suspense, {
    fallback: e.createElement("div", null, "Loading...")
  }, e.createElement(h, {
    onCloseDialog: a
  }))));
}

export default C;
export { y as IdentityContextProvider, C as IdentityModal, w as useIdentityContext };